<template>
  <div class="teaching-score-input-handle-config"
       :style="themeVars">
    <span class="trigger"
          @click="toggleVisible">
      <slot></slot>
      <span class="icon theme-text">
        <i class="el-icon-edit-outline"></i>
      </span>
    </span>
    <DataGridDialog :visible.sync="visible"
                    custom-class="teaching-score-input-handle-config-popover"
                    title="修改成绩规则"
                    width="720px">
      <div class="config-body"
           v-loading="committing"
           element-loading-text="数据提交中，请稍等...">
        <div class="main">
          <DataGrid size="mini"
                    resizable
                    auto-resize
                    :data="scoreTypes">
            <DataGridColumn title="类型"
                            field="name"
                            width="140"
                            align="center"></DataGridColumn>
            <DataGridColumn title="成绩比例（%）"
                            width="180"
                            align="center">
              <template #default="{row}">
                <el-input-number v-model.number="row.scale"
                                 size="mini"
                                 :min="0"
                                 :max="100"
                                 :precision="0"></el-input-number>
              </template>
            </DataGridColumn>
            <DataGridColumn v-if="scheduleScore.scoreGrades"
                            title="评分制"
                            align="center">
              <template #default="{row}">
                <el-checkbox-group v-model="row.grade"
                                   :disabled="!row.gradeEnabled">>
                  <el-checkbox v-for="scoreGrade in scheduleScore.scoreGrades"
                               :key="scoreGrade.bit"
                               :label="scoreGrade.bit">{{scoreGrade.name}}</el-checkbox>
                </el-checkbox-group>
              </template>
            </DataGridColumn>
          </DataGrid>
        </div>
        <div class="append">
          <div class="label">综合成绩：</div>
          <div class="value">
            <el-radio-group v-model="form.finalScoreGrade">
              <el-radio v-for="scoreGrade in scheduleScore.scoreGrades"
                        :key="scoreGrade.bit"
                        :label="scoreGrade.bit">{{scoreGrade.name}}</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="config-footer">
        <el-button size="mini"
                   type="primary"
                   :disabled="committing"
                   @click="handleApply">提交修改</el-button>
        <el-button size="mini"
                   type="default"
                   @click="handleClose">关闭窗口</el-button>
      </div>
    </DataGridDialog>
  </div>
</template>

<script>
import DataGridDialog from '../../../../../../../../elements/grid/DataGridDialog'
import DataGrid from '../../../../../../../../elements/DataGrid'
import DataGridColumn from '../../../../../../../../elements/DataGridColumn'
import Theme from '../../../../../../../../../mixins/theme'
import objectUtils from '../../../../../../../../../util/objectUtils'
import scoreGradeUtils from '../../../../../../../../../util/biz/scoreGradeUtils'
export default {
  name: 'TeachingScoreInputHandleConfig',
  mixins: [Theme],
  components: {
    DataGridDialog,
    DataGrid,
    DataGridColumn
  },
  props: {
    scheduleId: {
      type: String,
      required: true
    },
    scheduleScore: {
      type: Object,
      required: true
    }
  },
  data () {
    const scoreCodes = this.scheduleScore.scoreCodes || []
    return {
      visible: false,
      scoreTypes: scoreCodes.map(item => {
        return {
          ...item
        }
      }),
      form: {
        finalScoreGrade: ''
      },
      committing: false
    }
  },
  methods: {
    toggleVisible () {
      this.visible = !this.visible
    },
    initialConfig () {
      const scheduleScore = this.scheduleScore
      this.scoreTypes.forEach(scoreType => {
        const gradeType = scheduleScore[`${scoreType.code}Grade`]
        let grades = scoreGradeUtils.getMatched(scheduleScore.scoreGrades, gradeType)
          .map(item => item.bit)
        this.$set(scoreType, 'scale', scheduleScore[`${scoreType.code}Scale`])
        this.$set(scoreType, 'grade', grades)
      })
      Object.keys(this.form).forEach(key => {
        this.form[key] = scheduleScore[key]
      })
    },
    handleApply () {
      const scoreTypes = this.scoreTypes
      let isValid = scoreTypes.every(scoreType => {
        const scale = scoreType.scale
        if (!objectUtils.hasValue(scale)) {
          this.$message.warning(`请设置${scoreType.name}比例`)
          return
        }
        const grade = scoreType.grade
        if (!grade || !grade.length) {
          this.$message.warning(`请选择${scoreType.name}评分制`)
          return
        }
        return true
      })
      if (!isValid) {
        return
      }
      const sum = scoreTypes.reduce((p, v) => {
        return p + v.scale
      }, 0)
      if (sum !== 100) {
        this.$message.warning('各成绩比例之和不等于100')
        return
      }
      if (!this.form.finalScoreGrade) {
        this.$message.warning('请设置综合成绩评分制')
        return
      }
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/teaching/score/input/schedule/scoreConfig',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          scheduleId: this.scheduleId,
          configInfo: JSON.stringify({
            scoreItems: scoreTypes.map(scoreType => {
              return {
                code: scoreType.code,
                scale: scoreType.scale,
                grade: scoreType.grade
              }
            })
          })
        }, this.form))
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.handleClose()
              this.$nextTick(() => {
                let configInfo = response.data['configInfo']
                if (configInfo) {
                  Object.keys(configInfo).forEach(key => {
                    this.$set(this.scheduleScore, key, configInfo[key])
                  })
                }
                this.$emit('config-success')
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    },
    handleClose () {
      this.visible = false
    }
  },
  created () {
    this.initialConfig()
  },
  watch: {
    visible (val) {
      if (val) {
        this.initialConfig()
      }
    }
  }
}
</script>

<style lang="scss">
  .teaching-score-input-handle-config {
    & > .trigger {
      cursor: pointer;
      border-bottom: 1px solid transparent;
      transition: all .3s;
      &:hover {
        color: var(--theme-color);
        border-bottom-color: var(--theme-color);
      }
      & > .icon {
        i {
          font-size: 13px;
          vertical-align: -1px;
        }
      }
    }
  }
  .teaching-score-input-handle-config-popover {
    .config-body {
      padding: 15px;
      & > .main {
        .vxe-table {
          .vxe-table--header-wrapper {
            .vxe-table--header {
              .vxe-header--row {
                background-color: #f3f4f5;
              }
            }
          }
          .vxe-table--body-wrapper {
            .vxe-table--body {
              .vxe-body--row {
                .vxe-body--column {
                  .vxe-cell {
                    .el-input-number {
                      width: 120px;
                    }
                  }
                  .el-checkbox-group {
                    .el-checkbox {
                      .el-checkbox__label {
                        font-size: 12px;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      & > .append {
        margin-top: 15px;
        display: flex;
        align-items: center;
        & > .label {
          flex: none;
          font-size: 12px;
        }
        & > .value {
          margin-left: 10px;
          flex: auto;
          .el-radio-group {
            .el-radio {
              .el-radio__label {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
    .config-footer {
      height: 52px;
      background-color: #fff;
      border-top: 1px solid rgba(0,0,0,.05);
      text-align: center;
      line-height: 50px;
    }
  }
</style>
